@use '@design/bapf-pattern-library/source/sass/globals' as *;

.always-checked-box {
  &:hover {
    label,
    span {
      cursor: not-allowed;
    }
  }

  label {
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 0.25rem 0.25rem 0.25rem 0.5rem;
    color: $color-blue-dark;
    font-family: $font-family-sans-serif;
    line-height: 1.25rem;
    cursor: pointer;
  }

  span.ba-icon {
    margin: -0.2rem 0 0 0;
    &::before {
      margin-bottom: 5px;
    }
  }
}
